import { render, staticRenderFns } from "./LogicalSearch.vue?vue&type=template&id=6e9fda25&scoped=true"
import script from "./LogicalSearch.vue?vue&type=script&lang=js"
export * from "./LogicalSearch.vue?vue&type=script&lang=js"
import style0 from "./LogicalSearch.vue?vue&type=style&index=0&id=6e9fda25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9fda25",
  null
  
)

export default component.exports